import authAxios from "../../../common/authAxios";

export class EpvoSyncNameService {

    private static baseUrl = '/epvo-service/api/v1/epvo-sync';

    static sync() {
        return authAxios.put(`${this.baseUrl}`);
    }

    static syncByCodeNameId(id: number) {
        return authAxios.put(`${this.baseUrl}/${id}`);
    }

    static getAllEpvoSyncName() {
        return authAxios.get(`${this.baseUrl}/names`);
    }


    static getAllEpvoSyncHistory() {
        return authAxios.get(`${this.baseUrl}/history`);
    }
}
